import { Component, Inject, OnInit, computed, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CommonService } from 'src/app/services/common/common.service';
import { AddSessionDialogComponent } from '../add-session-dialog/add-session-dialog.component';
import { AddEventDialogComponent } from '../add-event-dialog/add-event-dialog.component';
import { DeleteConfirmationDialogComponent } from 'src/app/component/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { currencyIcons, dateformat } from 'src/app/models/commonModel';
import { OrderSuccessDialogComponent } from '../order-success-dialog/order-success-dialog.component';

@Component({
    selector: 'app-order-cart-dialog',
    templateUrl: './order-cart-dialog.component.html',
    styleUrls: ['./order-cart-dialog.component.scss'],
    standalone: false
})
export class OrderCartDialogComponent implements OnInit {

  // Common Properties
  customerId: any;
  customerData: any = null;
  events: any = [];
  currentDay: any;
  passId: any = [];
  sessionId: any = 0;
  cartData: any = signal([]);
  couponName: any = '';
  appliedCouponName: any;
  appliedCouponCodeId: any;
  discountType: any;
  discountValue: any = signal(0.0);
  taxPercentage: any = signal(0.0);
  paymentTypeList: any = [];
  selectedPaymentType: any = null;
  alltotal = computed(() => this.cartData().reduce((a, b) => a + (b.qty * b.fees), 0));
  calculatedTax = computed(() => this.commonService.makeDecimalRound(this.alltotal() - (this.alltotal() / (1 + (this.taxPercentage() / 100)))));
  subtotal = computed(() => this.alltotal() - this.calculatedTax());
  totalValue = computed(() => Math.max(this.subtotal() + this.calculatedTax() - parseFloat(this.discountValue()), 0));
  isCouponApplied: boolean = false;
  orderRemarks: any;
  isSendEmail: boolean = true;
  isDownloadReceipt: boolean = false;
  passData: any;
  sessionData: any;
  dateFormat: any;
  currency: any;
  orderDetail: any[] = [];
  couponDiscountedValue: any;
  isOrderFormSubmitted: boolean = false;
  isFitToPracticeYoga: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<OrderCartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private api: ApiUrlHelper,
    private dialog: MatDialog) {

    this.customerId = data.customerId;
    if (data?.event != null && data?.event != undefined) {
      data.event.qty = 1;
      this.events.push(data.event);
    }
    if (data?.passData != null && data?.passData != undefined) {
      this.passId = data?.passData
      this.sessionData = data?.classSessionData
      this.sessionId = data?.classSessionData.classSessionId
      this.fetchPassDetailById();
    }
    this.cartData.set(this.events);
  }

  ngOnInit(): void {
    this.fetchCustomerDataById();
    this.currentDay = new Date();
    this.getTaxPercentage();
    this.getPaymentTypeList();
    this.dateFormat = dateformat;
    this.currency = currencyIcons
  }

  cancel() {
    this.dialogRef.close();
  }

  addSession() {
    const dialogRef = this.dialog.open(AddSessionDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        customerId: this.customerId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.passId = result.passData
      this.sessionData = result.classSessionData
      this.sessionId = result.classSessionData.classSessionId
      this.fetchPassDetailById();

    })
  }

  addEvent() {
    const dialogRef = this.dialog.open(AddEventDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        customerId: this.customerId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      let eventIndex = this.events.findIndex(x => x.eventId === result.event.eventId);
      if (eventIndex >= 0) {
        this.events[eventIndex].qty = this.events[eventIndex].qty + 1
      }
      else {
        result.event.qty = 1;
        this.events.push(result.event);
      }
      this.cartData.set(this.events);
      this.changeDiscountValue();
    })
  }

  fetchCustomerDataById() {
    let api = this.api.apiUrl.Customer.GetCustomerById.replace('{Id}', this.customerId);
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.customerData = response.data;
        }
        else {
          this.spinner.hide();
          this.toaster.error(response.message);
        }
      }, error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  customerImageHandler() {
    this.customerData.images = '../../../assets/img/default-customer-profile.svg';
  }

  getCartData() {
    return this.cartData;
  }

  applyCouponCode() {
    if (!this.couponName || this.couponName == "") {
      this.toaster.error("Please enter coupon code.");
      return;
    }
    let obj = {
      couponCode: this.couponName,
      customerId: this.customerId
    }
    let api = this.api.apiUrl.Coupon.ApplyCouponCode;
    this.spinner.show();
    this.commonService.doPost(api, obj).subscribe({
      next: (response) => {
        if (response.success) {
          this.toaster.success(response.message);
          if (response.data) {
            this.spinner.hide();
            this.appliedCouponCodeId = response.data.couponCodeId;
            this.discountType = response.data.discountType;
            this.couponDiscountedValue = response.data.discountValue;
            if (this.discountType == 1) {
              this.discountValue.set(response.data.discountValue);
            }
            else {
              this.discountValue.set((this.alltotal() * response.data.discountValue) / 100);
            }
            this.isCouponApplied = true;
            this.appliedCouponName = this.couponName;
          }
        } else {
          this.appliedCouponCodeId = null;
          this.toaster.error(response.message);
          this.couponName = "";
          this.isCouponApplied = false;
          this.spinner.hide();
        }
        this.spinner.hide();
      },
      error: (error) => {
        this.toaster.error('An error occurred while apply coupon code.');
        this.spinner.hide();
      }
    });
  }

  onChangePromoCode(e) {
    if (this.couponName == '') {
      this.removeCoupon();
    }
    if (e.target?.value == '') {
      this.appliedCouponCodeId = null;
      this.discountType = '%';
      this.couponName = "";
    }
  }

  getTaxPercentage(): Promise<number> {
    let searchStr = "TaxPercentage";
    let api = this.api.apiUrl.SocialMediaLinks.GetSocialMediaLinks.replace('{Id}', searchStr);
    this.spinner.show();
    // Return a new Promise
    return new Promise<number>((resolve, reject) => {
      this.commonService.doGet(api).subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response.success) {
            // Resolve the promise with the value
            if (response.data[0].text && response.data[0].text != '') {
              this.taxPercentage.set(parseFloat(response.data[0].text))
            }
            else {
              this.taxPercentage.set(0.0)
            }
          } else {
            this.spinner.hide();
            // Reject the promise if not successful
            reject('Failed to get tax percentage');
          }
        },
        error: (error) => {
          this.spinner.hide();
          reject(error);
        }
      });
    });
  }

  getPaymentTypeList() {
    let api = this.api.apiUrl.Orders.GetAddOrderPassList
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.paymentTypeList = response.data;
          this.spinner.hide();
        } else {
          this.toaster.error(response.message);
          this.spinner.hide();
        }
      }, error: (error) => {
        this.spinner.hide();
      }
    });
  }

  addItem(param: any) {
    this.cartData.update(items =>
      items.map(x => {
        if (x.eventId == param.eventId) {
          x.qty = x.qty + 1
        }
        return x
      }));
    this.changeDiscountValue();
  }

  removeItem(param: any) {
    this.cartData.update(items =>
      items.map(x => {
        if (x.eventId == param.eventId) {
          if (x.qty === 1) {
            return x;
          }
          x.qty = x.qty - 1
        }
        return x
      }));
    if (param.qty >= 1 && this.appliedCouponCodeId > 0) {
      if (this.discountType == 1) {
        this.discountValue.set(this.discountValue());
      }
      else {
        this.discountValue.set(((this.subtotal() + this.calculatedTax()) * this.couponDiscountedValue) / 100);
      }
    }
  }

  selectPrintReceipt() {
    this.isDownloadReceipt = !this.isDownloadReceipt;
  }

  selectSendEmail() {
    this.isSendEmail = !this.isSendEmail;
  }

  fetchPassDetailById() {
    this.spinner.show();
    let api = this.api.apiUrl.Payment.GetPaymentTypeByID.replace('{Id}', this.passId);
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.passData = response.data;
          this.passData.fees = this.passData.amount;
          this.passData.qty = 1;
          this.spinner.hide();
          this.events.push(this.passData)
          this.cartData.set(this.events);
          this.changeDiscountValue();
        }
        else {
          this.spinner.hide();
          this.toaster.error(response.message);
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  transformCartDetails(cartdetails) {
    return cartdetails.map(item => {
      const isPaymentPass = item.paymentPassId !== undefined && item.paymentPassId !== null;
      return {
        classSessionId: isPaymentPass ? this.sessionId : 0,
        eventId: item.eventId || 0,
        eventQty: isPaymentPass ? 0 : (item.qty || 0),  // Set eventQty to 0 if isPaymentPass is true
        paymentPassId: item.paymentPassId || 0,
        rate: item.fees || 0,
        subTotal: item.fees ? item.fees * (item.qty || 1) : 0,
        isFitToPracticeYoga: true  // when admin add customer than by defult terms and conditions is true.
      };
    }).map(obj => {
      // Remove undefined properties
      if (obj.eventQty === undefined) {
        delete obj.eventQty;
      }
      return obj;
    });
  }

  addNewOrder() {
    this.isOrderFormSubmitted = true;
    if (this.selectedPaymentType > 0) {
      this.isOrderFormSubmitted = false;
      this.orderDetail = this.transformCartDetails(this.cartData());
      var api = this.api.apiUrl.Orders.AddOrder;
      var addOrderModel = {
        customerId: this.customerId,
        couponCodeId: this.appliedCouponCodeId | 0,
        subTotal: this.subtotal(),
        tax: this.calculatedTax(),
        discount: this.discountType == 1 ? this.alltotal() - this.discountValue() <= 0 ? this.subtotal() + this.calculatedTax() : this.discountValue() : this.discountValue(),
        total: this.totalValue(),
        checkoutEmail: this.customerData.email,
        firstName: this.customerData.firstName,
        lastName: this.customerData.lastName,
        email: this.customerData.email,
        contactNumber: this.customerData.phoneNumber,
        billingAddress: this.customerData?.customerAddress,
        billingCity: this.customerData?.city?.toString() ?? null,
        billingState: this.customerData?.state?.toString() ?? null,
        billingCountryId: this.customerData?.countryId?.toString() ?? null,
        billingZipCode: this.customerData?.postalCode,
        taxPer: this.taxPercentage(),
        couponDiscountPer: this.couponDiscountedValue,
        paymentTypeId: Number.parseInt(this.selectedPaymentType),
        remarks: this.orderRemarks,
        isEmailSend: this.isSendEmail,
        printRecipt: this.isDownloadReceipt,
        offSet: Intl.DateTimeFormat().resolvedOptions().timeZone == 'Asia/Calcutta' ? 'Asia/Kolkata' : Intl.DateTimeFormat().resolvedOptions().timeZone,
        orderDetail: this.orderDetail
      }
      this.spinner.show();
      this.commonService.doPost(api, addOrderModel).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            this.spinner.hide();
            const dialogRef = this.dialog.open(OrderSuccessDialogComponent, {
              width: '400px',
              disableClose: true,
              autoFocus: false,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (this.isDownloadReceipt) {
                this.downloadPdf(response.data);
              }
              this.dialog.closeAll();
            });
          }
          else {
            this.spinner.hide();
            this.toaster.error(response.message);
          }
        },
        error: (err) => {
          this.spinner.hide();
          console.log(err);
        }
      });
    }
  }

  removeItemFromCart(item: any) {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      width: '400px',
      disableClose: true,
      autoFocus: false,
      data: {
        action: item.name,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (item.eventId > 0) {
          this.cartData.update(items => items.filter(cartEvent => cartEvent.eventId !== item.eventId));
          let filterCartData = this.cartData().filter(cartEvent => cartEvent.eventId !== item.eventId);
          this.events = filterCartData;
          this.cartData.set(filterCartData)
          this.changeDiscountValue();
        }
        if (item.paymentPassId > 0) {
          this.cartData.update(items => items.filter(cartEvent => cartEvent.paymentPassId !== item.paymentPassId));
          let filterCartData = this.cartData().filter(cartEvent => cartEvent.paymentPassId !== item.paymentPassId);
          this.events = filterCartData;
          this.sessionId = 0;
          this.changeDiscountValue();
        }
        if (this.cartData().length == 0) {
          this.removeCoupon();
          this.isDownloadReceipt = false;
          this.isSendEmail = false;
          this.orderRemarks = '';
          this.selectedPaymentType = null;
        }
      }
    });
  }

  removeCoupon() {
    this.discountValue.set(0);
    this.isCouponApplied = false;
    this.appliedCouponName = "";
    this.couponName = "";
    this.appliedCouponCodeId = 0;
  }

  eventImageErrorHandler(image: any) {
    image.images = '../../../../../assets/img/dummyEvent.png';
  }

  changeDiscountValue() {
    if (this.appliedCouponCodeId > 0) {
      if (this.discountType == 1) {
        this.discountValue.set(this.discountValue());
      }
      else {
        this.discountValue.set(((this.subtotal() + this.calculatedTax()) * this.couponDiscountedValue) / 100);
      }
    }
  }

  downloadPdf(url: any) {
    const filename = 'OrderReceipt.pdf';
    this.commonService.downloadAndSavePdf(url, filename);
  }
}